<script setup lang="ts">
import HeaderLogo from '~/assets/img/ys_footer_logo.svg'; // Импорт логотипа для хедера
import { RoleEnum } from '~/types/User';
import ButtonLocationSelect from '~/components/custom-ui/ButtonLocationSelect.vue';
import UserProfileMenuBar from '~/components/layouts/UserProfileMenuBar.vue';
import AuthMainElement from '~/components/layouts/AuthMainElement.vue';
//import FooterLogo from '~/assets/img/ys_footer_logo.svg';

const userStore = useUserStore();
const config = useRuntimeConfig();

const homeLink = computed(() => {
    return userStore.isAuthenticated && userStore.user?.user_role === RoleEnum.MASTER ? { name: 'office_task_search' } : { name: 'home' }
})
</script>

<template>
    <header class="container" :class="{
        'hidden md:block': userStore.isAuthenticated,
        'test-header': !userStore.isAuthenticated
    }">
        <div class="flex justify-between ys-header">
            <nav class="flex items-center space-x-4 xl:space-x-5">
                <NuxtLink :to="homeLink" class="cursor-pointer rtl:ml-4">
                    <HeaderLogo class="flex-none ys-logo" />
                </NuxtLink>

                 <template v-if="userStore.isAuthenticated">
                    <!-- Навигационные элементы для пользователей с ролью 'CUSTOMER' -->
                    <template v-if="userStore.user?.user_role === 'CUSTOMER'">
                        <NuxtLink :to="{ name: 'office' }" class="ml-3 sm:ml-0 !p-1 sm:p-3 ys-header-nav-button  items-center hidden md:flex">
                            <Icon size="20" name="ri:file-list-line" />
                            <p>{{ $t("My orders") }}</p>
                        </NuxtLink>
                        <NuxtLink :to="{ name: 'office_chats' }" class="!p-1 sm:p-3 ys-header-nav-button items-center !ml-0 md:!ml-5 hidden md:flex">
                            <Icon size="20" name="ri:chat-3-line" />
                            <p class="hidden md:block">{{ $t("Chats") }}</p>
                            <span class="new-messages-icon" v-if="userStore.unreadResponsesCount">{{ userStore.unreadResponsesCount }}</span>
                        </NuxtLink>
                    </template>

                    <!-- Навигационные элементы для пользователей с ролью 'MASTER' -->
                    <template v-if="userStore.user?.user_role === 'MASTER'">
                        <NuxtLink :to="{ name: 'office' }" class="ml-3 sm:ml-0 !p-1 sm:p-3 ys-header-nav-button items-center hidden md:flex">
                            <Icon size="20" name="ri:dashboard-line" />
                            <p class="hidden md:block">{{ $t("My tasks") }}</p>
                        </NuxtLink>
                        <NuxtLink :to="{ name: 'office_chats' }" class="!p-1 sm:p-3 !ml-0 md:!ml-5 ys-header-nav-button items-center hidden md:flex">
                            <Icon size="20" name="ri:chat-3-line" />
                            <p class="hidden md:block">{{ $t("Chats") }}</p>
                            <!-- Отображение количества новых сообщений -->
                            <span class="new-messages-icon" v-if="userStore.unreadResponsesCount">{{ userStore.unreadResponsesCount }}</span>
                        </NuxtLink>
                    </template>
                 </template>

                 <!-- Кнопка с указанием текущего местоположения (например, Дубай), доступная неавторизованным пользователям -->
                <ButtonLocationSelect v-else btn_class="max-h-[36px] px-2 text-sub hover:text-main" />
            </nav>
            <!-- Второй навигационный блок -->
            <nav class="flex space-x-2 xl:space-x-4 items-center">

                <template v-if="userStore.isAuthenticated">
                    <!-- Ссылка для создания заказа для пользователей с ролью 'CUSTOMER' -->
                    <NuxtLink v-if="userStore.user?.user_role === 'CUSTOMER'" :to="{ name: 'order_create' }"
                        class="ys-header-nav-button items-center hidden md:flex">
                        <Icon size="18" name="ri:sticky-note-line" />
                        <p class="hidden md:block">{{ $t("Create Order") }}</p>
                    </NuxtLink>

                    <UiButton v-if="userStore.currentRole && [RoleEnum.CUSTOMER, RoleEnum.MASTER].includes(userStore.currentRole)" as-child class="rounded-full bg-[#FAA41A] hover:bg-[#fa861a]">
                        <NuxtLink
                            :to="{ name: 'office_jobtoken' }">
                            <Icon size="18" name="custom:jobtoken-simple" />
                            <p class="hidden md:block ml-2">{{ $t("Jobtoken") }}</p>
                        </NuxtLink>
                    </UiButton>

                    <!-- Ссылка для поиска задач для пользователей с ролью 'MASTER' -->
                    <NuxtLink v-if="userStore.user?.user_role === 'MASTER'"
                        :to="{ name: 'office_task_search' }" class="ys-header-nav-button items-center hidden md:flex">
                        <Icon size="18" name="ri:search-2-line" />
                        <p class="hidden md:block">{{ $t("Tasks search") }}</p>
                    </NuxtLink>

                    <!-- Меню пользователя для авторизованных пользователей -->
                    <UserProfileMenuBar class="rtl:!mr-4 rtl:!ml-0" />
                </template>

                <template v-else>
                    <!-- <LayoutsLanguageSelector class="rtl:ml-4" /> -->

                    <!-- Кнопка для авторизации для неавторизованных пользователей -->
                    <AuthMainElement :icon="true" class="ltr:ml-2 rtl:!ml-0" />
                </template>
            </nav>
        </div>
    </header>
</template>

<style scoped lang="scss">
.ys-header-nav-button {
    @apply my-auto cursor-pointer;
    color: rgba(82, 88, 102, 1);
    background: unset;
    text-decoration: unset;
    border-radius: 8px;
    font-size: 14px;
    height: 36px;
    padding: 8px 12px 8px 12px;
    gap: 8px;

    &:hover {
        background: rgba(246, 248, 250, 1);
    }
}
</style>